// extracted by mini-css-extract-plugin
module.exports = {"settingDrawerStyleHandler":"index_settingDrawerStyleHandler__3Kivp","title":"index_title__qVxKE","themeColor":"index_themeColor__1hA9-"};